import { render, staticRenderFns } from "./pmtList.vue?vue&type=template&id=379a68cd&scoped=true"
import script from "./pmtList.vue?vue&type=script&lang=js"
export * from "./pmtList.vue?vue&type=script&lang=js"
import style0 from "./pmtList.vue?vue&type=style&index=0&id=379a68cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a68cd",
  null
  
)

export default component.exports